// src/components/auth/ProtectedRoute.jsx
// Componente HOC que protege rutas requiriendo autenticación
// Redirige a /login si el usuario no está autenticado

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Componente que protege rutas privadas
 * Si el usuario no está autenticado, redirige a /login
 * Guarda la ubicación original para redirigir después del login
 * 
 * @param {React.ReactNode} children - Componentes a renderizar si está autenticado
 */
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Mientras verifica la sesión, mostrar loading
  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-amber-500 mb-4"></div>
          <div className="text-white text-xl">Verificando sesión...</div>
        </div>
      </div>
    );
  }

  // Si no hay usuario autenticado, redirigir a login
  // Guardamos la ubicación actual para redirigir después del login
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Usuario autenticado, renderizar el contenido protegido
  return children;
};

export default ProtectedRoute;